module.exports = __webpack_public_path__ + "img/paypal-lock.a3ea5a9e.gif";